<div [ngClass]="{'sidebar-open': isDrawerOpen, 'sidebar-closed': !isDrawerOpen}"
     class="dashboard-container">
  @if (isDrawerOpen && isMobile) {
    <div (click)="toggleMobileMenu()"
         class="mobile-overlay"></div>
  }

  <aside [ngClass]="{
           'sidebar-open': isDrawerOpen,
           'sidebar-expanded': closeMenu,
           'sidebar-collapsed': !closeMenu
         }"
         class="sidebar">
    <div class="sidebar-header">
      <div class="logo-section">
        <div (click)="isMobile ? toggleMobileMenu() : toggleSidebar()"
             class="logo-icon">
          <!-- Dashboard Icon -->
          <svg fill="currentColor"
               viewBox="0 0 24 24">
            <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
          </svg>
        </div>
        @if (closeMenu) {
          <h3 class="logo-text">ربلان</h3>
        }
      </div>
      <button (click)="isMobile ? toggleMobileMenu() : toggleSidebar()"
              [attr.aria-label]="closeMenu ? 'بستن منو' : 'باز کردن منو'"
              class="sidebar-toggle">
        <svg fill="currentColor"
             viewBox="0 0 24 24">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    <nav class="sidebar-nav">
      <div (click)="onHomeClicked()"
           [ngClass]="{'active': selectedIndex === -1}"
           class="nav-item home-item">
        <div class="nav-icon">
          <svg fill="currentColor"
               viewBox="0 0 24 24">
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
          </svg>
        </div>
        @if (closeMenu) {
          <span class="nav-text">خانه</span>
        }
        <div class="nav-indicator"></div>
      </div>

      @for (menuCategory of menuCategories; track menuCategory; let i = $index) {
        <div class="nav-section">
          <div (click)="onMenuCategoryClicked(menuCategory, i)"
               (keydown.enter)="onMenuCategoryClicked(menuCategory, i)"
               (keydown.space)="onMenuCategoryClicked(menuCategory, i)"
               [ngClass]="{'active': selectedIndex === i, 'expanded': menuCategory.Status}"
               class="nav-item category-item"
               role="button"
               tabindex="0">
            <div class="nav-icon">
              <svg fill="currentColor"
                   viewBox="0 0 24 24">
                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
              </svg>
            </div>

            @if (closeMenu) {
              <span class="nav-text">{{ menuCategory.Title | onlinetranslate }}</span>
              <div [ngClass]="{'rotated': menuCategory.Status}"
                   class="nav-arrow">
                <svg fill="currentColor"
                     viewBox="0 0 24 24">
                  <path d="M7 10l5 5 5-5z"/>
                </svg>
              </div>
            }

            <div class="nav-indicator"></div>
          </div>

          @if (menuCategory.Status && closeMenu) {
            <div [@slideDown]
                 class="submenu">
              @for (menuLink of menuCategory.MenuLinks; track menuLink) {
                <div (click)="onMenuLinkClicked(menuLink)"
                     (keydown.enter)="onMenuLinkClicked(menuLink)"
                     (keydown.space)="onMenuLinkClicked(menuLink)"
                     [ngClass]="{'active': selectedLinkId === menuLink.PermissionId}"
                     class="submenu-item"
                     role="menuitem"
                     tabindex="0">
                  <span class="submenu-text">{{ menuLink.Title }}</span>
                  <div class="submenu-indicator"></div>
                </div>
              }
            </div>
          }
        </div>
      }
    </nav>

    @if (closeMenu) {
      <div class="sidebar-footer">
        <div class="user-info">
          <div class="user-avatar">
            <svg fill="currentColor"
                 viewBox="0 0 24 24">
              <path
                d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </div>
          <div class="user-details">
            <p class="user-name">{{ Config.userInformation?.FirstName | onlinetranslate }}</p>
            <p class="user-role">مدیر سیستم</p>
          </div>
        </div>
      </div>
    }
  </aside>
  <main [ngClass]="{'content-expanded': closeMenu, 'content-collapsed': !closeMenu}"
        class="main-content">
    <header [ngClass]="{'scrolled': isScrolled}"
            class="top-header">
      <div class="header-content">
        <div class="header-left">
          <button (click)="isMobile ? toggleMobileMenu() : toggleSidebar()"
                  [attr.aria-label]="isDrawerOpen ? 'بستن منو' : 'باز کردن منو'"
                  class="mobile-menu-btn">
            <span [ngClass]="{'active': isDrawerOpen}"
                  class="hamburger-line"></span>
            <span [ngClass]="{'active': isDrawerOpen}"
                  class="hamburger-line"></span>
            <span [ngClass]="{'active': isDrawerOpen}"
                  class="hamburger-line"></span>
          </button>
          <div class="page-title-section">
            <h1 class="page-title">عنوان صفحه</h1>
          </div>
        </div>
        <div class="header-right">
          <div class="theme-toggle-container">
            <button (click)="toggleTheme()"
                    [attr.aria-label]="currentTheme === 'light' ? 'تغییر به حالت روشن' : 'تغییر به حالت تاریک'"
                    class="theme-toggle-btn"
                    type="button">
              @if (currentTheme === 'dark') {
                <svg class="theme-icon"
                     fill="currentColor"
                     viewBox="0 0 24 24">
                  <path
                    d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"/>
                </svg>
              }
              @if (currentTheme === 'light') {
                <svg class="theme-icon"
                     fill="currentColor"
                     viewBox="0 0 24 24">
                  <path
                    d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-3.03 0-5.5-2.47-5.5-5.5 0-1.82.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"/>
                </svg>
              }
            </button>
          </div>
          <div class="notification-container">
            <button [attr.aria-label]="'اعلان‌ها'"
                    class="notification-btn"
                    type="button">
              <svg fill="currentColor"
                   viewBox="0 0 24 24">
                <path
                  d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
              </svg>
              <span class="notification-badge">3</span>
            </button>
          </div>
          <div class="user-profile-container">
            <div [attr.aria-expanded]="false"
                 class="user-profile"
                 data-bs-toggle="dropdown"
                 role="button"
                 tabindex="0">
              <div class="user-avatar">
                @if (Config.userInformation?.Image) {
                  <img [alt]="Config.userInformation?.FirstName"
                       [src]="Config.userInformation?.Image"
                       class="avatar-img">
                } @else {
                  <svg fill="currentColor"
                       style="width: 100%; height: 100%; color: white;"
                       viewBox="0 0 24 24">
                    <path
                      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                }
              </div>
              <div class="user-info">
                <p class="user-name">{{ Config.userInformation?.FirstName | onlinetranslate }}</p>
                <p class="user-email">{{ Config.userInformation?.MobileNumber }}</p>
              </div>
              <svg class="dropdown-arrow"
                   fill="currentColor"
                   viewBox="0 0 24 24">
                <path d="M7 10l5 5 5-5z"/>
              </svg>
            </div>
            <ul class="dropdown-menu profile-dropdown">
              <li>
                <button (click)="openProfileClicked()"
                        class="dropdown-item">
                  <svg fill="currentColor"
                       viewBox="0 0 24 24">
                    <path
                      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                  <span>پروفایل</span>
                </button>
              </li>
              <li>
                <button (click)="onSignOutClicked()"
                        class="dropdown-item">
                  <svg fill="currentColor"
                       viewBox="0 0 24 24">
                    <path
                      d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
                  </svg>
                  <span>خروج</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
    <div [dir]="textDirection"
         class="page-content p-0">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
